var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchActive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.71719 0C10.2422 0 13.1095 2.95111 13.1095 6.57919C13.1095 8.2909 12.4713 9.85208 11.4268 11.0238L13.482 13.1345C13.6743 13.3325 13.675 13.6527 13.4826 13.8507C13.3868 13.9507 13.2601 14 13.1341 14C13.0087 14 12.8826 13.9507 12.7861 13.852L10.7062 11.7173C9.61209 12.6191 8.2248 13.1591 6.71719 13.1591C3.19216 13.1591 0.324219 10.2073 0.324219 6.57919C0.324219 2.95111 3.19216 0 6.71719 0ZM6.71719 1.01343C3.73503 1.01343 1.30886 3.50985 1.30886 6.57919C1.30886 9.64853 3.73503 12.1456 6.71719 12.1456C9.6987 12.1456 12.1249 9.64853 12.1249 6.57919C12.1249 3.50985 9.6987 1.01343 6.71719 1.01343Z",
    fill: "#2D6CDF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchActive);
export default __webpack_public_path__ + "static/media/search-active.7a37e4192af094a819695425e52584b3.svg";
export { ForwardRef as ReactComponent };